import React from 'react';
import logo from '../../assets/logo.png';
import './footer.css';

const Footer = () => {
  return (
    <div className='pl__footer section__padding'>
      <div className='pl__footer-top'>
        <img src={logo} alt="Logo Pantja Laundry" />
        <p>Jalan Raya Joglo No. 14, Kel. Joglo - Kembangan. Jakarta Barat 11640</p>
      </div>
      <div className='pl__footer-bottom'>
        <p>© 2022 Pantja Laundry. All rights reserved.</p>
        <p>Website created by mniqbale</p>
      </div>
    </div>
  )
}

export default Footer